export class MsbModel {
  token!: string;
  refreshToken!: string;

  setAuth(msb: MsbModel) {
    this.token = msb.token;
    this.refreshToken = msb.refreshToken;
  }
}
